module.exports = __webpack_public_path__ + "media/images/main_events/2024/icon-drop-7453b41ae81c59fcca2a68703f474767.svg";